import { ArbetsgivardeklarationParsningsRespons } from "../../types/nya/ekonomi/faktura/modell/Kundfaktura";
import axiosInstance, { endpoints } from "../../lib/axios";
import { SkattekontoutdragRespons } from "../../types/nya/ekonomi/skatt/SkatteTyper";
import { LöneResponse } from "../../types/nya/ekonomi/loner/LoneTyper";

export type ISkatteverketStatus = {
  ansluten: boolean;
  scopes: string[];
  löperUtVid: string | null;
  kräverFörnyelse: boolean;
};

export function parsaArbetsgivarDeklarationer(filer: File[], orgId: string): Promise<LöneResponse> {
  const formData = new FormData();
  for (let i = 0; i < filer.length; i++) {
    const fil = filer[i];
    formData.append('xx', fil);
  }
  
  return axiosInstance.post(endpoints.lön.arbetsgivardeklarationer.filuppladdning + '/' + orgId, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => response.data);
}

export function parsaSkattekontoutdrag(filer: File[], orgid: string): Promise<SkattekontoutdragRespons> {

  const formData = new FormData();
  formData.append('skattekontoutdrag', filer[0]);
  return axiosInstance.post(endpoints.skatt.skatteutdrag.filuppladdning + '/' + orgid, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => response.data);
}

export function hämtaSkattekontoutdrag(orgid: string): Promise<SkattekontoutdragRespons> {

  return axiosInstance.get(endpoints.skatt.skatteutdrag.root + '/' + orgid)
    .then(response => response.data);
}

export function raderaSkatteutdrag(orgid: string): Promise<void> {
  return axiosInstance.delete(endpoints.skatt.skatteutdrag.root + '/utkast/' + orgid)
    .then(response => response.data);
}

export function repareraLänkningAvBanktransaktioner(orgid: string): Promise<void> {
  return axiosInstance.post(endpoints.skatt.skatteutdrag.repareraLänkning(orgid))
    .then(response => response.data);
}

export function hämtaSkatteverketStatus(orgId: string): Promise<ISkatteverketStatus> {
  return axiosInstance.get(`/api/organisationer/${orgId}/skatteverket/auth/status`)
    .then(response => response.data);
}

export function hämtaSkatteverketAuthorizeUrl(orgId: string, scopes?: string[]): Promise<string> {
  const query = scopes?.length ? `?scopes=${scopes.join(',')}` : '';
  return axiosInstance.get(`/api/organisationer/${orgId}/skatteverket/auth/authorize-url${query}`)
    .then(response => response.data.url);
}

export function kopplaBortSkatteverket(orgId: string): Promise<void> {
  return axiosInstance.delete(`/api/organisationer/${orgId}/skatteverket/auth/anslutning`)
    .then(response => response.data);
}
